import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class SystemsService {
  async getAllSystemsWithFilter({
    accountId,
    programId,
    requestBody,
    systemSortBy,
    systemPageNoAPI,
    systemPageSize,
    systemActive,
    systemStatus
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/system/${programId}?sort_by=${systemSortBy || ''
      }&page_no=${systemPageNoAPI || ''}&page_size=${systemPageSize || ''
      }&active=${systemActive || ''}${systemActive === '2' ? '&status=APPLICATION_SUBMITTED' : ''
      }&status=${systemStatus || ''}`,
      MICROSERVICES.ENROLLMENTMANAGER,
    )
    return await service
      .put(url, requestBody)
      .then((response) => {
        const { data } = response
        return data.data
      })
      .catch((error) => error)
  }

  async getAllSystems(account_id, program_id, payload, page_no, page_size, status) {
    let params = { page_no, page_size, ...(status ? { status } : {}) }
    try {
      const response = await service.put(
        Urls.getApiUrl(
          `admin/${account_id}/system/${program_id}`,
          MICROSERVICES.ENROLLMENTMANAGER,
        ),
        payload,
        { params },
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllColumns(currentUser, program_id) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${currentUser.account_id}/${program_id}/columns`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getMapDetails(currentUser, program_id) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${currentUser.account_id}/tags/${program_id}/search`, MICROSERVICES.ENROLLMENTMANAGER), { operator: "AND", tags: {} }, { params: { is_active: 1 } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemDetail(account_id, enrollment_id, site_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/system/${enrollment_id}/${site_id}`,
          MICROSERVICES.ENROLLMENTMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getTableData(account_id, program_id, site_id, page_no, page_size, time = 2, sortBy, order) {
    const params = { page_no: page_no - 1, page_size: page_size, time: time, sort_by: sortBy, ascending: order === 'ascending' }
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/vppevent/${program_id}/${site_id}/all`,
          MICROSERVICES.VPPMANAGER,
        ), { params: params }
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getCalendarEvents(account_id, program_id, site_id, fromDate, toDate) {
    let params = { start_date: fromDate, end_date: toDate, page_no: -1, page_size: -1 }
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/vppevent/${program_id}/${site_id}/calendar/all`,
          MICROSERVICES.VPPMANAGER,
        ), { params: params }
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getDeviceInfo(account_id, site_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site/${site_id}/site_device_info`,
          MICROSERVICES.SITEMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getGridMode(account_id, site_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site/${site_id}/grid_mode`,
          MICROSERVICES.TELEMETRYMANAGER,
        )
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateGridMode(account_id, site_id, grid_mode) {
    try {
      const response = await service.put(
        Urls.getApiUrl(
          `admin/${account_id}/site/${site_id}/grid_mode`,
          MICROSERVICES.SITEMANAGER,
        ),
        null,
        { params: { mode: grid_mode } }
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemsLifetimeGraph(account_id, siteId, isDailyEnergy) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site/${siteId}/energy_graph?daily=${isDailyEnergy}`,
          MICROSERVICES.TELEMETRYMANAGER,
        )
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemsDailyGraph(account_id, siteId, isDailyEnergy, start_date, end_date) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site/${siteId}/energy_graph?daily=${isDailyEnergy}&start_date=${start_date}&end_date=${end_date}`,
          MICROSERVICES.TELEMETRYMANAGER,
        )
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateApplicationStatus(account_id, application_Id, newstatus) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${account_id}/application/${application_Id}/unenroll`, MICROSERVICES.ENROLLMENTMANAGER), null, { params: { newstatus } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async unenrollSite(accountId, programId, siteId) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/application/${programId}/${siteId}/unenroll`, MICROSERVICES.ENROLLMENTMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getApplicationsByType(accountId, program_id, site_id, application_type) {
    const params = { program_id, site_id, application_type }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/application/all`, MICROSERVICES.ENROLLMENTMANAGER), { params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async putSiteSync(accountId, siteId, programId){
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/enrollment/syncSiteInfo?programId=${programId}`, MICROSERVICES.ENROLLMENTMANAGER), siteId)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  
  async getSiteEnrollmentInfo(system_id){
    try {
      const response = await service.get(Urls.getApiUrl(`admin/*/enrollment/approved/${system_id}`, MICROSERVICES.ENROLLMENTMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateEnrollmentParticipationType(accountId, siteId, nextType) {
    try { 
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/enrollment/${siteId}/participation_type?type=${nextType}`, MICROSERVICES.ENROLLMENTMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const systemsService = new SystemsService()
